var KNB = require('./compiled/interface');

var env = require('./env');
if (env.isDPApp) {
  require.ensure([],function(require) {
    KNB.load(require('./compiled/dpapp'));
    KNB._ready();
  },'dpapp');
} else if (env.isMTNB) {
  require.ensure([],function(require) {
    KNB.load(require('./compiled/mtnb'));
    KNB._ready();
  },'mtnb');
} else if (env.isHBNB) {
  require.ensure([],function(require) {
    KNB.load(require('./compiled/hbnb'));
    KNB._ready();
  },'hbnb');
} else if ((env.isWX || env.isMiniProgramWebview) && typeof _KNB_IGNORE_WECHAT === 'undefined') {
  require.ensure([],function(require) {
    KNB.load(require('./compiled/wx'));
    KNB._ready();
  },'wx');
} else if (env.isTitans) {
  require.ensure([],function(require) {
    KNB.load(require('./compiled/titans'));
    KNB._ready();
  },'titans');
} else if (env.isDPZeus) {
  require.ensure([],function(require) {
    KNB.load(require('./compiled/dpzeus'));
    KNB._ready();
  },'dpzeus');
} else {
  KNB._ready();
}

module.exports = KNB;

